export default {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
}
